import * as Constants from '../constants';

const initialState = { tabStates: [false, false, false, false] };

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case Constants.CUSTOMER_INFO:
      return Object.assign({}, state, { tabStates: [true, false, false, false] });
    case Constants.ADD_PRODUCTS:
      return Object.assign({}, state, { tabStates: [true, true, false, false] });
    case Constants.SELECT_ADDRESS:
      return Object.assign({}, state, { tabStates: [true, true, true, false] });
    case Constants.SET_RX_AVAILABILITY:
      return Object.assign({}, state, { tabStates: [true, true, true, true] });
    case Constants.DOC_CONSULT_SEARCH:
      return Object.assign({}, state, { tabStates: [true, true, false, false] });
    case Constants.DOC_CONSULT_SELECT_DOCTOR:
      return Object.assign({}, state, { tabStates: [true, true, true, false] });
    case Constants.DOC_CONSULT_SLOT_PATIENT:
      return Object.assign({}, state, { tabStates: [true, true, true, true] });
    case Constants.SERVICE_PLATFORM_SELECT_PACKAGE:
      return Object.assign({}, state, { tabStates: [true, true, false, false] });
    case Constants.SERVICE_PLATFORM_SLOT_PATIENT:
      return Object.assign({}, state, { tabStates: [true, true, true, false] });
    default:
      return { ...state };
  }
}
